import type { NavigateFunction } from 'react-router-dom';
import { hostPaths } from '@/utils/hostPaths';

/** Pop N history entries when possible; otherwise replace onto game rekap. */
export function navigateBackToGameRekap(
  navigate: NavigateFunction,
  gameSlug: string,
  historySteps = 1
): void {
  const idx = (window.history.state as { idx?: number } | null)?.idx;
  if (typeof idx === 'number' && idx >= historySteps && historySteps > 0) {
    navigate(-historySteps);
    return;
  }
  navigate(hostPaths.mabar.gameRekap(gameSlug), { replace: true });
}
